import { NavItem } from '@/dashboard/components/nav-item';
import * as dashboardActions from '@/dashboard/dashboard-actions';
import searchIcon from '@iconify/icons-ant-design/search-outline';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export function UniversalSearch() {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(
      dashboardActions.toggleUniversalSearch({ isUniversalSearchActive: true })
    );
  }, [dispatch]);

  return (
    <NavItem
      id="search"
      icon={searchIcon}
      tooltip="Search"
      ariaLabel="Open search menu"
      isActive={false} // To avoid applying active navigation item styles
      onClick={onClick}
    />
  );
}
